// Function to show or hide the popup based on localStorage
function showLocationPopup() {
  if (Shopify.country !== 'US') {
    const lastClosed = localStorage.getItem('location_popup_closed');
    const now = new Date();

    if (lastClosed && (now - new Date(lastClosed)) / (1000 * 60 * 60 * 24) < 7) {
      document.querySelector('.location_popup').style.display = 'none';
    } else {
      document.querySelector('.location_popup').style.display = 'block';
    }
  }
}

// Function to close the popup and save the close time in localStorage
function closeLocationPopup() {
  document.querySelector('.location_popup').style.display = 'none';
  localStorage.setItem('location_popup_closed', new Date().toISOString());
}

// Function to update text for elements dynamically
function updateTextForElements(data) {
  if (!data) return;

  const helperTextElement = document.querySelector('.location_popup_text');
  const elementIcons = [
    document.querySelector('#loc_popup-icon-1 .item_title'),
    document.querySelector('#loc_popup-icon-2 .item_title'),
    document.querySelector('#loc_popup-icon-3 .item_title'),
    document.querySelector('#loc_popup-icon-4 .item_title'),
    document.querySelector('#loc_popup-icon-5 .item_title'),
  ];
  
  // Update helper text
  if (helperTextElement) {
    helperTextElement.innerText = data.main_text || '';
  }

  // Update icon text
  elementIcons.forEach((icon, index) => {
    if (icon && data[`icon_${index + 1}`]) {
      icon.innerText = data[`icon_${index + 1}`];
    }
  });

  // Update cookie text if available
  if (data.cookie_text) {
    const checkElement = setInterval(() => {
      const cookieText = document.querySelector('.shopify-pc__banner__body p');
      if (cookieText) {
        clearInterval(checkElement);
        cookieText.innerHTML = data.cookie_text;
      }
    }, 100);
  }
}

// Function to update the helper text based on the user's country
function updateHelperText() {
  const countryData = metaLanguages[Shopify.country];
  if (countryData) {
    updateTextForElements(countryData);
  } else {
    // Default text for countries without specific data
    const defaultText = {
      main_text: 'FREE International Shipping with a minimum purchase of $99.',
    };
    updateTextForElements(defaultText);
  }
}

// Event listener for closing the popup
document.querySelector('#close_location_popup').addEventListener('click', closeLocationPopup);
document.querySelector('.location_popup_overlay').addEventListener('click', closeLocationPopup);

// Run the update and show popup on page load
document.addEventListener('DOMContentLoaded', function () {
  updateHelperText();
  showLocationPopup();
});
